/* NixCart — product page behaviour: gallery, variants, quantity breaks, AJAX add-to-cart,
   tabs, urgency counter, sticky bar. No dependencies. Works with Dawn's cart drawer. */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(n, d, t, s) {
      d = d == null ? 2 : d; t = t || ','; s = s || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(d);
      var p = n.split('.');
      return p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (p[1] ? s + p[1] : '');
    }
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function initRoot(root) {
    if (root.dataset.ncReady) return; root.dataset.ncReady = '1';
    var product = JSON.parse(root.querySelector('[data-nc-product-json]').textContent);
    var moneyFormat = JSON.parse(root.querySelector('[data-nc-money-format]').textContent);
    var form = root.querySelector('[data-nc-form]');
    var idInput = root.querySelector('[data-nc-variant-id]');
    var qtyInput = root.querySelector('[data-nc-qty]');
    var current = product.variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || product.variants[0];

    /* ---- Gallery ---- */
    var gallery = root.querySelector('[data-nc-gallery]');
    var slides = gallery ? gallery.querySelectorAll('.nc-gallery__slide') : [];
    var thumbs = gallery ? gallery.querySelectorAll('[data-nc-thumb]') : [];
    var index = 0;
    function show(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === index);
        if (n !== index) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === index);
        if (n === index && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
      });
    }
    if (gallery) {
      var prev = gallery.querySelector('[data-nc-prev]'), next = gallery.querySelector('[data-nc-next]');
      prev && prev.addEventListener('click', function () { show(index - 1); });
      next && next.addEventListener('click', function () { show(index + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.ncThumb); }); });
      var main = gallery.querySelector('.nc-gallery__main'), x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1)); x0 = null;
      });
    }
    function showMedia(mediaId) {
      slides.forEach(function (s, n) { if (s.dataset.mediaId === String(mediaId)) show(n); });
    }

    /* ---- Price rendering ---- */
    var breaksWrap = root.querySelector('[data-nc-breaks]');
    function renderPrices() {
      var now = root.querySelector('[data-nc-price-now]'), was = root.querySelector('[data-nc-price-was]');
      if (now) now.textContent = formatMoney(current.price, moneyFormat);
      if (was) {
        if (current.compare_at_price && current.compare_at_price > current.price) { was.hidden = false; was.textContent = formatMoney(current.compare_at_price, moneyFormat); }
        else was.hidden = true;
      }
      var total = current.price * (+(qtyInput ? qtyInput.value : 1) || 1);
      if (breaksWrap) breaksWrap.querySelectorAll('[data-nc-break]').forEach(function (b) {
        var q = +b.dataset.qty, d = +b.dataset.discount, full = current.price * q, tp = Math.round(full * (100 - d) / 100);
        var set = function (sel, v) { var el = b.querySelector(sel); if (el) el.textContent = formatMoney(v, moneyFormat); };
        set('[data-nc-break-price]', tp); set('[data-nc-break-was]', full);
        set('[data-nc-break-save]', full - tp); set('[data-nc-break-each]', Math.round(tp / q));
        if (b.classList.contains('is-selected')) total = tp;
      });
      root.querySelectorAll('[data-nc-atc-total]').forEach(function (el) { el.textContent = formatMoney(total, moneyFormat); });
      var pl = root.querySelector('[data-nc-paylater]');
      if (pl) pl.querySelector('[data-nc-paylater-amt]').textContent = formatMoney(Math.round(current.price / (+pl.dataset.months || 1)), moneyFormat);
      var btn = root.querySelector('[data-nc-atc]'), lbl = root.querySelector('[data-nc-atc-label]');
      if (btn && lbl) { btn.disabled = !current.available; lbl.textContent = current.available ? lbl.dataset.add : lbl.dataset.sold; }
      document.querySelectorAll('[data-nc-sticky-price]').forEach(function (el) { el.textContent = formatMoney(total, moneyFormat); });
    }

    /* ---- Variant picker ---- */
    root.querySelectorAll('[data-nc-option]').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = [];
        product.options.forEach(function (_, i) {
          var c = root.querySelector('[data-nc-option="' + i + '"]:checked');
          selected[i] = c ? c.value : null;
          var label = root.querySelector('[data-nc-option-value="' + i + '"]');
          if (label && c) label.textContent = c.value;
        });
        var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
        if (!match) return;
        current = match;
        if (idInput) idInput.value = match.id;
        if (match.featured_media) showMedia(match.featured_media.id);
        root.querySelectorAll('[data-nc-unit]').forEach(function (s) { s.value = match.id; });
        renderPrices();
        var url = new URL(window.location.href); url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      });
    });

    /* ---- Quantity breaks ---- */
    if (breaksWrap) {
      breaksWrap.querySelectorAll('[data-nc-break]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
          breaksWrap.querySelectorAll('[data-nc-break]').forEach(function (o) { o.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          b.querySelector('input').checked = true;
          if (qtyInput) qtyInput.value = b.dataset.qty;
          renderPrices();
        });
      });
      var pre = breaksWrap.querySelector('[data-nc-break].is-selected');
      if (pre && qtyInput) qtyInput.value = pre.dataset.qty;
    }

    /* ---- Add to cart / Buy now ---- */
    function openDrawerOrRedirect(res) {
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (drawer && typeof drawer.renderContents === 'function' && res && res.sections && Object.keys(res.sections).length) {
        try { drawer.classList.remove('is-empty'); drawer.renderContents(res); return; } catch (e) { /* fall through */ }
      }
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
    function collectItems() {
      var sel = breaksWrap && breaksWrap.querySelector('[data-nc-break].is-selected');
      var units = sel ? sel.querySelectorAll('[data-nc-unit]') : [];
      if (units.length) {
        var map = {};
        units.forEach(function (s) { map[s.value] = (map[s.value] || 0) + 1; });
        return Object.keys(map).map(function (id) { return { id: +id, quantity: map[id] }; });
      }
      return [{ id: +idInput.value, quantity: +(qtyInput ? qtyInput.value : 1) || 1 }];
    }
    var modeEl = root.querySelector('[data-nc-mode]');
    var buyNow = modeEl && modeEl.value === 'buy_now';
    window.ncAddToCart = function (items, btn, direct) {
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (!direct && drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
      }
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Could not add to cart');
        if (direct) { window.location.href = '/checkout'; return; }
        if (!res.id && res.items && res.items[0]) { res.id = res.items[0].id; res.key = res.items[0].key; }
        openDrawerOrRedirect(res);
      }).finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
    };
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = root.querySelector('[data-nc-error]'); if (err) err.hidden = true;
        var btn = form.querySelector('[data-nc-atc]');
        window.ncAddToCart(collectItems(), btn, buyNow).catch(function (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; }
        });
      });
    }

    /* ---- Tabs ---- */
    root.querySelectorAll('[data-nc-tabs]').forEach(function (t) {
      t.querySelectorAll('[data-nc-tab]').forEach(function (b) {
        b.addEventListener('click', function () {
          t.querySelectorAll('[data-nc-tab]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          t.querySelectorAll('[data-nc-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.ncPanel === b.dataset.ncTab); });
        });
      });
    });

    /* ---- Sticky mobile bar ---- */
    var sticky = document.querySelector('[data-nc-sticky]');
    var atc = root.querySelector('[data-nc-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
      var sbtn = sticky.querySelector('button');
      sbtn && sbtn.addEventListener('click', function () { if (form) form.requestSubmit(); });
    }
    renderPrices();
  }

  function boot() { document.querySelectorAll('[data-nc-product-root]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
